import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, ListChecks, HardDrive, Radio, HeartPulse } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Maestra Protocolo 72 Horas',
    desc: 'El manual paso a paso de supervivencia urbana.',
    icon: <BookOpen className="w-6 h-6" data-id="element-198" />
  }, {
    title: 'Inventario "Caja Negra"',
    desc: 'La lista exacta de lo que entra en la mochila y lo que se queda.',
    icon: <ListChecks className="w-6 h-6" data-id="element-199" />
  }, {
    title: 'Protocolo de Blindaje Digital',
    desc: 'Cómo crear tu vida en un pendrive encriptado para reconstruir todo después del desastre.',
    icon: <HardDrive className="w-6 h-6" data-id="element-200" />
  }, {
    title: 'Plan de Comunicación familiar',
    desc: 'Qué hacer exactamente cuando el internet y las llamadas fallan.',
    icon: <Radio className="w-6 h-6" data-id="element-201" />
  }, {
    title: 'BONUS: Guía del Botiquín de Trauma',
    desc: 'Los 5 elementos que salvan vidas mientras llega la ambulancia.',
    icon: <HeartPulse className="w-6 h-6" data-id="element-202" />,
    isBonus: true
  }];
  return <section className="py-24 px-4 bg-brand-gray border-t border-brand-border" data-id="element-203">
      <div className="max-w-5xl mx-auto" data-id="element-204">
        <FadeIn data-id="element-205">
          <div className="text-center mb-16" data-id="element-206">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase" data-id="element-207">
              Lo que obtienes <span className="text-brand-orange" data-id="element-208">HOY</span>
            </h2>
            <div className="w-24 h-1 bg-brand-orange mx-auto mt-6" data-id="element-209" />
          </div>
        </FadeIn>

        <div className="grid gap-6" data-id="element-210">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-211">
              <div className={`p-6 rounded-xl border flex flex-col sm:flex-row items-start sm:items-center gap-6 transition-all hover:bg-brand-dark ${item.isBonus ? 'border-brand-orange bg-brand-orange/5 shadow-[0_0_20px_rgba(255,102,0,0.1)]' : 'border-brand-border bg-brand-dark/50'}`} data-id="element-212">
                <div className={`p-4 rounded-lg flex-shrink-0 ${item.isBonus ? 'bg-brand-orange text-white' : 'bg-brand-gray text-brand-orange border border-brand-border'}`} data-id="element-213">
                  {item.icon}
                </div>
                <div data-id="element-214">
                  <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-3" data-id="element-215">
                    {item.title}
                    {item.isBonus && <span className="text-xs font-bold bg-brand-orange text-white px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-216">
                        Gratis
                      </span>}
                  </h3>
                  <p className="text-gray-400 text-lg" data-id="element-217">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}